import type { HTMLAttributes, ReactNode } from 'react';

import useClassy from '@core/hooks/useClassy';
import Button from '@ui/Button';
import Flex from '@ui/Flex';
import Icon from '@ui/Icon';
import Title from '@ui/Title';

import classes from './style.module.scss';

export interface ModalHeaderProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  className?: string;
  position?: 'between' | 'center';
  title?: string;
  toggleClose?: () => void;
}

export default function ModalHeader({
  children,
  className,
  toggleClose,
  position = 'between',
  title,
  ...attrs
}: ModalHeaderProps) {
  const bem = useClassy(classes, 'Modal-Header');

  return (
    <header className={bem('&', className)} {...attrs}>
      <Flex align={title ? 'start' : 'center'} gap="size-8" justify={position}>
        <div>
          {!!title && (
            <Title as={2} className={bem('-title')} level={4}>
              {title}
            </Title>
          )}
          {children}
        </div>
        {!!toggleClose && (
          <Button aria-label="Close" ghost kind="minimum" onClick={toggleClose} size="sm">
            <Icon aria-hidden="true" name="x" />
          </Button>
        )}
      </Flex>
    </header>
  );
}
